import { FieldValues } from 'react-hook-form';
import { ParsedField } from '@/components/Questionnaire/form/helpers/parseFieldKey';

const getBoxIndexOutputFields = (field: ParsedField, formValues: FieldValues): Array<{ index: number, key: string }> => {
  if (field.listFieldKey !== null && field.rowIndex !== null) {
    const numRows = (formValues[field.listFieldKey] as Array<unknown>).length;
    const outputRows: Array<{ index: number, key: string }> = [];
    for (let i = field.rowIndex; i < numRows; i += 1) {
      outputRows.push({index: i, key: (`${field.listFieldKey}[${i}].${field.fieldKey}`) });
    }
    return outputRows;
  }
  return [];

};

export default getBoxIndexOutputFields;